// Shared constants for the Admin pages — role catalog, plan catalog, and the
// color styling each uses for its small status pills. These were duplicated
// (or about to be duplicated) across AdminUsersPage and the extracted modals,
// so they live here as the single source of truth.

export const ROLES = [
  { value: "admin",       label: "Admin",       description: "Full platform control + user management" },
  { value: "client_user", label: "Client User", description: "Upload data, view dashboards, generate reports" },
  { value: "read_only",   label: "Read Only",   description: "View dashboards only — no upload, no exports" },
];

export const PLANS = [
  { value: "starter",      label: "Starter",      sublabel: "$799/mo · 2,500 denials · 2 seats · 50 appeals" },
  { value: "professional", label: "Professional", sublabel: "$1,499/mo · 25,000 denials · 5 seats · Unlimited appeals" },
  { value: "enterprise",   label: "Enterprise",   sublabel: "Custom · Unlimited everything" },
];

export const PLAN_STYLES = {
  starter:      { color: "#475569", bg: "rgba(100,116,139,0.12)" },
  professional: { color: "#0F766E", bg: "rgba(20,184,166,0.12)" },
  enterprise:   { color: "#7C3AED", bg: "rgba(124,58,237,0.12)" },
};

export const ROLE_STYLES = {
  admin:       { color: "#7C3AED", bg: "rgba(124,58,237,0.10)" },
  client_user: { color: "#0F766E", bg: "rgba(20,184,166,0.10)" },
  read_only:   { color: "#475569", bg: "rgba(100,116,139,0.10)" },
};
